import { useEffect, useState } from 'react'
import type { CountdownTimerPropsType } from './types'
import { calculateTimeLeft, formatTime } from './utils'

export const CountdownTimer = (props: CountdownTimerPropsType) => {
  const [timeLeft, setTimeLeft] = useState(() =>
    calculateTimeLeft({
      remainingMilliseconds: props.remainingMilliseconds,
    }),
  )
  const [remainingTime, setRemainingTime] = useState(
    props.remainingMilliseconds,
  )

  useEffect(() => {
    const intervalId = setInterval(() => {
      setRemainingTime((prev) => {
        const newRemainingTime = prev - 1000
        if (newRemainingTime <= 0) {
          clearInterval(intervalId)
          return 0
        }
        return newRemainingTime
      })
    }, 1000)

    return () => clearInterval(intervalId)
  }, [])

  useEffect(() => {
    setTimeLeft(
      calculateTimeLeft({
        remainingMilliseconds: remainingTime,
      }),
    )
  }, [remainingTime])

  return formatTime(timeLeft)
}
